module.exports = __webpack_public_path__ + "img/p2-15.2afdef21.png";